import React, { useState } from "react";
import { Container, Button, Row, Col } from "reactstrap";
import { CardDisplay, QuestionImport, AnswersCard } from "../../components";

function QuestionsBank() {
  document.title = "Questions Bank | RTS";
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [isNewQuestion, setIsNewQuestion] = useState(false);
  const [modal, setModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditable, setIsEditable] = useState({});

  const toggle = () => setModal(!modal);

  const handleNewButtonClick = () => {
    setSelectedCardId(null);
    setIsNewQuestion(true);
  };

  const handleEditClick = (id, forceEnable = false) => {
    setIsEditable((prevState) => ({
      ...prevState,
      [id]: forceEnable ? true : !prevState[id], // Enable edit mode explicitly if forceEnable is true
    }));
  };

  const cardProps = {
    selectedCardId,
    setSelectedCardId,
    setIsNewQuestion,
    questions,
    setQuestions,
    loading,
    setLoading,
    error,
    setError,
    handleEditClick,
  };

  const importProps = {
    setLoading,
    setError,
    setQuestions,
    toggle,
    modal,
  };

  return (
    <div
      className="page-content"
      style={{ backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <Container fluid>
        <Row className="mb-3">
          <Col lg={12}>
            <div className="d-flex flex-row align-items-center justify-content-between">
              <h5>Questions Bank</h5>
              <div className="d-flex flex-row gap-2 align-items-center">
                <Button
                  onClick={toggle}
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #C3D3E2",
                    color: "#000",
                    padding: "8px 20px",
                    borderRadius: "8px",
                  }}
                >
                  <div className="d-flex flex-row align-items-center gap-1">
                    <span className="mdi mdi-upload-outline"></span>
                    <span>Import</span>
                  </div>
                </Button>
                <Button
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #C3D3E2",
                    color: "#000",
                    padding: "8px 20px",
                    borderRadius: "8px",
                  }}
                >
                  <div className="d-flex flex-row align-items-center gap-1">
                    <span className="mdi mdi-filter-variant"></span>
                    <span>Filter</span>
                  </div>
                </Button>
                <Button
                  style={{
                    backgroundColor: "#3F88E4",
                    border: "none",
                    color: "#fff",
                    padding: "8px 20px",
                    borderRadius: "8px",
                  }}
                  onClick={() => {
                    handleNewButtonClick();
                    handleEditClick(null, true);
                  }}
                >
                  <div className="d-flex flex-row align-items-center gap-1">
                    <span className="mdi mdi-plus"></span>
                    <span>New</span>
                  </div>
                </Button>
              </div>
              <QuestionImport {...importProps} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={7}>
            <CardDisplay {...cardProps} />
          </Col>
          <Col lg={5}>
            <AnswersCard
              id={isNewQuestion ? null : selectedCardId}
              setQuestions={setQuestions}
              setSelectedCardId={setSelectedCardId}
              isEditable={isEditable}
              handleEditClick={handleEditClick}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default QuestionsBank;
